import {
  DataArray,
  UpdateIconButton,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  TestTypeListDto,
  TestTypeListResource,
  TestTypeListFilter,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { testTypePageRoute } from "../TestTypesPage/TestTypePage";

export const TestTypeTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  testType: TestTypeListDto[];
  setTestType: (testType: TestTypeListDto[]) => void;
  resource: TestTypeListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
  listFilter: TestTypeListFilter;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "7%" }}>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<TestTypeListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<TestTypeListDto>("testType"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<TestTypeListDto>("testTypeGroup"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<TestTypeListDto>("aprCategory"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.testType.map((testTypeItem) => (
            <TableRow
              key={testTypeItem.id}
              onClick={() =>
                navigate(
                  testTypePageRoute.getPath({
                    id: testTypeItem.id,
                    crudMode: "view",
                    screenType: "dialog"
                  })
                )
              }
            >
              <TableCell>{testTypeItem.id}</TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center" justifyContent={"space-between"}>
                  <Typography variant="inherit">{testTypeItem.testType}</Typography>
                </Stack>
              </TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center" justifyContent={"space-between"}>
                  <Typography variant="inherit">{testTypeItem.testTypeGroup}</Typography>
                </Stack>
              </TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center" justifyContent={"space-between"}>
                  <Typography variant="inherit">{testTypeItem.aprCategory}</Typography>
                </Stack>
              </TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate(
                        testTypePageRoute.getPath({
                          id: testTypeItem.id,
                          crudMode: "edit",
                          screenType: "dialog"
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
